import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectServiceRequestsListItems } from "../../../../../../redux/service-requests/selector";
import { serviceRequests } from "../../../../../../redux/service-requests/action";
import { selectListItems } from "../../../../../../redux/library/selector";

const ServiceRequestsContainer = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const itemsData = useSelector(selectServiceRequestsListItems)
  const libraryData = useSelector(selectListItems)
  const [ columnDefs,setColumnDefs] = useState({});
  console.log(libraryData,'libraryData')
    const createColumnDefs: any = () => {
      setColumnDefs([
        {
          field: 'Sl',
          sortable: false,
          filter: false,
          isSortLabel: true,
          headerName: 'Sl',
          cellRenderer (params: any) {
            return parseInt(
              params.node.id,
              10
            ) + 1;
          },
        },
        { field: 'RequestorName', headerName: 'Name' },
        { field: 'RequestorPhoneNo', headerName: 'Phone Number' },
        { 
          field: 'ServiceRequestStatusId', headerName: 'Service Request Status', 
          cellRenderer: 'libraryRendererComponent', 
          cellRendererParams:  { library: libraryData?.result?.ServiceRequestStatus }
        },
        { 
          field: 'ServiceRequestTypeId', headerName: 'Service Request Type', 
          cellRenderer: 'libraryRendererComponent', 
          cellRendererParams: { library: libraryData?.result?.ServiceRequestType }
        },
        { field: 'Subject', headerName: 'Subject' },
        { field: 'CreatedOnUtc', headerName: 'CreatedDate /Time', isDateValueFormat: true },
        { field: 'ModifiedOnUtc', headerName: 'ModifiedDate /Time', isDateValueFormat: true }    
      ]);
    }

  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
  
  const handleDelete=(data: any)=>{
    dispatch(serviceRequests.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/cma/service-requests/delete`,
      entity: 'serviceRequests',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
  })).then(() => {
    dispatch(serviceRequests.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/cma/service-requests/list`,
      entity: 'serviceRequests',
      jsonData: { "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",}
    }));
  });
  }
      
//   const additionButtons: any = [
//     {
//       name: 'Add Service Requests',
//       callback: () => handleAdd(),
//     }
//   ];

  const fetchServiceRequests=()=>{

    dispatch(serviceRequests.list({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/cma/service-requests/list`,
      entity:'serviceRequests',
      jsonData:{
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc"
    }}))     
  }
	useEffect(() => {
   
    createColumnDefs()
    fetchServiceRequests()
	}, [pageData,pageSize])
    
	return (
    <>
    {itemsData?.isLoading ? 
    <PageLoader /> :  
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={itemsData?.result?.pagination}  headingName="Service Requests" />
    }
    </>
	);
};

export default ServiceRequestsContainer;


